import { Routes, Route, Navigate } from "react-router-dom";
import { PublicLayout } from "./publicLayout";
import { PrivateLayout } from "./privateLayout";
import { AppRoutesUI } from "../config/appRoutes";
import { NotFoundPage } from "../pages/notFound";

export const AppLayout = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={<Navigate to={AppRoutesUI.Home.Path()} replace />}
      />
      <Route path={AppRoutesUI.NotFound.Route} element={<NotFoundPage />} />
      <Route path={`${AppRoutesUI.Auth.Route}/*`} element={<PublicLayout />} />
      <Route path="/*" element={<PrivateLayout />} />
    </Routes>
  );
};
